export const NAVIGATE_TO_STEP = "NAVIGATE_TO_STEP";
export const SEARCH_ROOMS_GET_PROPERTIES_FOR_HOUSING_PERIOD = "SEARCH_ROOMS_GET_PROPERTIES_FOR_HOUSING_PERIOD";
export const SEARCH_ROOMS_GET_PROPERTIES_FOR_HOUSING_PERIOD_SUCCESS = "SEARCH_ROOMS_GET_PROPERTIES_FOR_HOUSING_PERIOD_SUCCESS";
export const SEARCH_ROOMS_GET_PROPERTIES_FOR_HOUSING_PERIOD_ERROR = "SEARCH_ROOMS_GET_PROPERTIES_FOR_HOUSING_PERIOD_ERROR";
export const SEARCH_ROOMS = "SEARCH_ROOMS";
export const SEARCH_ROOMS_SUCCESS = "SEARCH_ROOMS_SUCCESS";
export const SEARCH_ROOMS_ERROR = "SEARCH_ROOMS_ERROR";
export const SEARCH_ROOMS_RESET_FORM = "SEARCH_ROOMS_RESET_FORM";
export const ASSIGN_ROOM = "ASSIGN_ROOM";
export const ASSIGN_ROOM_SUCCESS = "ASSIGN_ROOM_SUCCESS";
export const ASSIGN_ROOM_ERROR = "ASSIGN_ROOM_ERROR";
export const CLEAR_ROOM_ASSIGNMENT_RESPONSE = "CLEAR_ROOM_ASSIGNMENT_RESPONSE";
export const SET_ROOMS_SELECTED = "SET_ROOMS_SELECTED";
export const DEALLOCATE_ROOM = "DEALLOCATE_ROOM";
export const DEALLOCATE_ROOM_SUCCESS = "DEALLOCATE_ROOM_SUCCESS";
export const DEALLOCATE_ROOM_ERROR = "DEALLOCATE_ROOM_ERROR";
export const CLEAN_DEALLOCATE_STUDENTS = "CLEAN_DEALLOCATE_STUDENTS";
export const RESET_DEALLOCATE_ROOM_FINISH = "RESET_DEALLOCATE_ROOM_FINISH";
export const CLEAR_ROOM_SEARCH_RESULTS = "CLEAR_ROOM_SEARCH_RESULTS";